/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_CopiedInputs */

const cs_action_copied = /** @type {(inputs: Action_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkopírováno`)
};

const en_action_copied = /** @type {(inputs: Action_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Action_CopiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_copied = /** @type {((inputs?: Action_CopiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_CopiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_copied(inputs)
	return cs_action_copied(inputs)
});